import {HistoryStorageWithMaterial} from '@domain/material-storage'
import {getUtcOffset} from '@hconnect/common/utils'
import {dateFormatter, timeFormatter} from '@hconnect/uikit/src/common'
import {Typography} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {adjustEnLocale, getStoragesGroupedByUpdate} from '../selectors'

export const LastSiloMeasurements: React.FC<{
  silos: HistoryStorageWithMaterial[]
  timezoneId: string
}> = ({silos, timezoneId}) => {
  const {
    t,
    i18n: {language}
  } = useTranslation(FEATURE_NAMESPACE)
  const silosGroupedByUpdate = getStoragesGroupedByUpdate(silos)
  return (
    <>
      {silosGroupedByUpdate.map((group) => (
        <Typography variant="caption" key={group.measuredAt}>
          {t('stock.lastSiloMeasurements', {
            silos: group.storages.map((silo) => silo.name).join(', '),
            date: dateFormatter(
              group.measuredAt,
              adjustEnLocale(language),
              getUtcOffset(timezoneId)
            ),
            time: timeFormatter(group.measuredAt, language, getUtcOffset(timezoneId))
          })}
        </Typography>
      ))}
    </>
  )
}
